import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { QuickDespatchBookResult, QuickDespatchPack } from '../../models';
import { TmsWebBaseService } from '../base';

/**
 * Finishes a quick despatch (QuickDespatchAndBookShipping) once the user has answered the packs or
 * shipping details prompt. Booking prints the despatch note once it is booked; a cancelled prompt
 * calls nothing (quick-despatch-amendments, D-2). Most screens should go through
 * QuickDespatchHandlerService rather than calling this directly.
 */
@Injectable({
  providedIn: 'root',
})
export class QuickDespatchService extends TmsWebBaseService {
  constructor() {
    super('QuickDespatch');
  }

  /** Saves the packs (when given), books the shipping, then prints the note if booked. 200 even when not booked. */
  book(despatchNoteId: string, packs?: QuickDespatchPack[]): Observable<QuickDespatchBookResult> {
    return this.httpService.post<QuickDespatchBookResult>(`${this.apiUrl}/Book`, { despatchNoteId, packs });
  }
}
